// PortfolioPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, Github } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import './PublicPages.css';

function PortfolioPage() {
  const { data, loading } = useApp();
  const items = data.portfolio || [];
  return (
    <div>
      <div className="portfolio-hero">
        <div className="section-tag">Our Work</div>
        <h1 className="section-heading">Portfolio</h1>
        <p style={{ color: 'var(--text-muted)', fontSize: '1rem', maxWidth: 500, margin: '0 auto' }}>
          Explore our latest projects and the innovative solutions we've built for clients across various industries.
        </p>
      </div>
      <div className="section-container">
        <div className="portfolio-grid">
          {loading && <p style={{ color: 'var(--text-muted)', gridColumn: '1/-1', textAlign: 'center' }}>Loading portfolio…</p>}
          {!loading && items.length === 0 && <p style={{ color: 'var(--text-muted)', gridColumn: '1/-1', textAlign: 'center' }}>No portfolio items yet. Add them in Admin → Website.</p>}
          {items.map(p => (
            <a key={p.id} href={p.url || '#'} target="_blank" rel="noreferrer" className="portfolio-card">
              <div className="portfolio-card-img">
                {p.logoUrl ? (
                  <img src={p.logoUrl} alt="" className="portfolio-card-logo-img" />
                ) : (
                  <span>{p.logo}</span>
                )}
              </div>
              <div className="portfolio-card-body">
                <h3 className="portfolio-card-name">{p.name}</h3>
                <p className="portfolio-card-desc">{p.desc}</p>
                <div className="project-tech-tags" style={{ marginBottom: 14 }}>
                  {(p.tech || []).map(t => <span key={t} className="tech-tag">{t}</span>)}
                </div>
                <div style={{ display: 'flex', gap: 10 }}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: '0.78rem', color: 'var(--secondary-color)', fontWeight: 600 }}>
                    <ExternalLink size={12} /> View Live
                  </span>
                  {p.github && (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: '0.78rem', color: 'var(--text-muted)' }}>
                      <Github size={12} /> GitHub
                    </span>
                  )}
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PortfolioPage;
